import { Metamodel } from 'app/model/base/model';
import { FormatWriteSettings } from './format-write-settings';
import { IcebergDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.iceberg.formatWrite,
    tags: { datasetModel: Metamodel.modelFor(IcebergDataset) }
})
export class IcebergFormatWriteSettings extends FormatWriteSettings {
}
